import axios from "../http-client/axios";
import { SCORPIONS_URL } from "../urls/base-urls";

export async function getMedicalOperationAreas() {
  const resp = await axios.get(`${SCORPIONS_URL}/operation-areas`);
  return resp.data;
}
